import React  from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { errorsFormRegisterState, valuesFormRegisterState } from '../../state/atoms';
import RutField from '../../components/RutField';
import NamesField from '../../components/NamesField';
import LastnamePatField from '../../components/LastnamePatField';
import LastnameMatField from '../../components/LastnameMatField';
import BirthDateField from '../../components/BirthDateField';
import GeneroAutocomplete from '../../components/GeneroAutocomplete';
import PrevisionAutocomplete from '../../components/PrevisionAutocomplete';
import EmailField from '../../components/EmailField';
import PhoneMobileField from '../../components/PhoneMobileField';
import LandlineField from '../../components/LandlineField';
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom"
import useSavePatient from 'src/Patient/hooks/useSavePatient';

const FormCompleteInformation = () => {
    const { phoneEmpty } = useRecoilValue(errorsFormRegisterState);
    const { handleChange } = useSavePatient();
    const { uswEmailConfirm } = useRecoilValue(valuesFormRegisterState);
    const { uswEmailConfirm: errorUswEmailConfirm } = useRecoilValue(errorsFormRegisterState);
    
    return (
        <>
            <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                    <RutField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <NamesField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <LastnamePatField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <LastnameMatField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <BirthDateField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <GeneroAutocomplete />
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabelCustom htmlFor="autcomplete-prevision" text="Previsión (Opcional)" />
                    <PrevisionAutocomplete />
                </Grid>

                <Grid item container xs={12} spacing={2}>
                    <Grid item md={6} xs={12}>
                        <EmailField />
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputLabelCustom htmlFor="input-email" text="Confirmar Correo electrónico (*)" />
                        <TextField
                            id="input-email-confirm"
                            size="small"
                            error={errorUswEmailConfirm && errorUswEmailConfirm.length > 0 ? true : false}
                            helperText={errorUswEmailConfirm && errorUswEmailConfirm.length > 0 ? `${errorUswEmailConfirm.join("\n")}` : ''}
                            style={{ width: '100%' }}
                            name="uswEmailConfirm"
                            type="text"
                            value={uswEmailConfirm || ""}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onChange={handleChange}
                            autoComplete="off"
                            placeholder='Ej: correo@dominio.cl'
                            onCopy={
                                (e) => 
                                    e.preventDefault()
                            }
                            onPaste={
                                (e) => 
                                    e.preventDefault()
                            }
                        />
                    </Grid>
                </Grid>

                <Grid item md={6} xs={12}>
                    <PhoneMobileField />
                </Grid>
                <Grid item container md={6} xs={12}>
                    <LandlineField />
                </Grid>
                {
                    phoneEmpty.length > 0 && (
                        <Grid item xs={12} md={12} display={"flex"} justifyContent={"center"}>
                            <Typography color="error" fontSize={"0.75rem"}>{phoneEmpty.join("\n")}</Typography>
                        </Grid>
                    )
                }
            </Grid>
        </>
    )
}

export default FormCompleteInformation;